const Attribute = (props) => (
    <div className="attribute">
        <p>{props.name}</p>
        <div>
            <span className="transition-all duration-2000" style={{ width: props.percent}}></span>
        </div>
    </div>
)

export default Attribute